import { render, staticRenderFns } from "./PreviewModel.vue?vue&type=template&id=22e6635d"
import script from "./PreviewModel.vue?vue&type=script&lang=js"
export * from "./PreviewModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports